<template>
    <div class="score-list">
        <a-table size="small" :pagination="false" :loading="loading"
            :columns="columns" :data-source="data" rowKey="id"
        >
            <verdict-icon slot="verify" slot-scope="verify" :verify="verify" />
            <a class="tower-title" slot="name" slot-scope="title, record" :href="`/tower/name=${ record.name }`" target="_blank">{{ title }}</a>
            <a-icon slot="platform" slot-scope="platform" :type="calIcon(platform)" />
            <span slot="timestamp" slot-scope="timestamp">{{ formatDate(timestamp)}}</span>
            <a slot="route" slot-scope="id" :href="`/backend/score/download.php?id=${ id }`">
                <a-icon type="download" />
            </a>
            <template slot="footer">
                <a-pagination :current="Number($route.params.page)" :total="score" 
                    :defaultPageSize="20" @change="change" :hideOnSinglePage="true"
                />
            </template>
        </a-table>
    </div>
</template>

<script>
import VerdictIcon from '@/components/VerdictIcon.vue'

import { mapState } from 'vuex';
import axios from '../../../plugins/axios';

const Memo = {};

export default {
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            vm.load(to.params.page);
        });
    },
    async beforeRouteUpdate(to, from, next) {
        await this.load(to.params.page);
        next();
    },
    data: () => ({
        data: [],
        loading: false,
        columns: [
            { dataIndex: 'verify', slot: 'verify' },
            { title: '塔名', dataIndex: 'title', slot: 'name' },
            { title: '难度', dataIndex: 'hard' },
            { title: '结局', dataIndex: 'ending' },
            { title: '分数', dataIndex: 'hp' },
            { title: '攻击', dataIndex: 'atk' },
            { title: '防御', dataIndex: 'def' },
            { title: '魔防', dataIndex: 'mdef' },
            { title: '游戏时间', dataIndex: 'totalTime' },
            { title: '平台', dataIndex: 'platform', slot: 'platform' },
            { title: '提交时间', dataIndex: 'timestamp', slot: 'timestamp' },
            { title: 'IP', dataIndex: 'ip' },
            { title: '录像', dataIndex: 'id', slot: 'route' },
        ].map(e => e.slot ? { ...e, scopedSlots: { customRender: e.slot } } : e )
    }),
    computed: {
        ...mapState('$user', [ 'userid', 'score' ]),
    },
    methods: {
        async load(key) {
            if (!Memo[key]) {
                this.loading = true;
                const { data } = await axios.get(`/backend/user/my.php?id=${ this.userid }&type=score&page=${ key }`);
                Memo[data.page] = data.score;
                this.loading = false;
            }
            this.data = Memo[key];
        },
        change(page) {
            this.$router.push({ name: 'score', params: { page } });
        },
        calIcon(platform) {
            if (platform == 'Android') return 'android';
            if (platform == 'PC') return 'desktop';
            if (platform == 'iOS') return 'apple';
        },
        formatDate(timestamp) {
            return (new Date(timestamp * 1000)).toLocaleString("cn-ZH", { hour12: false });
        },
    },
    components: {
        VerdictIcon
    }
}
</script>

<style lang="less" scoped>
.tower-title {
    min-width: 60px;
    display: inline-block;
}
.score-list {
    .ant-table-wrapper {
        width: fit-content;
        min-width: 100%;
    }
    overflow-x: auto;
}
</style>